import React from "react";
import styled from "styled-components";
import { Box } from "../Box";
import { style } from "../style";

export type PropNote = React.ReactNode | { value: React.ReactNode; persist?: boolean };

const InputNote = styled.span`
  color: ${style.colors.grey.dark};
  font-size: ${style.vars.fontSize.small};
`;

export const PropNote = {
  normalize(note: PropNote): { value: React.ReactNode; persist: boolean } {
    if (!note) {
      return { value: null, persist: false };
    }

    if (!React.isValidElement(note) && typeof note === "object" && "persist" in note) {
      return { persist: false, ...note };
    }

    return { value: note, persist: false };
  },

  renderForAfterInput(note: React.ReactNode) {
    if (!note) {
      return null;
    }

    return (
      <Box display="block" mt={1}>
        <InputNote>{note}</InputNote>
      </Box>
    );
  },
};
